import React, { useMemo } from "react";
import styled, { css } from "styled-components";
import { useImages } from "../hooks/useImages";
import Spinner from "./Spinner";

const Courses = ({
  data = [],
  getIsAllowed = (course) => false,
  onClick = (course) => { },
  className
}) => {
  return (
    <Container className={className}>
      {data.map((course) => {
        const isAllowed = getIsAllowed(course);
        return (
          <React.Fragment key={course.id}>
            <CourseBox
              className="courseBox"
              onClick={() => (isAllowed ? onClick(course) : null)}
              isAllowed={isAllowed}
            >
              <Image src={course.image} />
              <Title>{course.title}</Title>
            </CourseBox>
          </React.Fragment>
        );
      })}
    </Container>
  );
};


const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`;

const CourseBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  border-radius: 20px;
  overflow: hidden;
  background-color: white;

  width: calc(50% - 14px);
  min-height: 150px;

  margin: 7px;

  cursor: pointer;

  user-select: none;

  ${(props) =>
    !props.isAllowed &&
    css`
      cursor: default;
      background-color: #f5f5f5;
      & > * {
        opacity: 0.5;
      }
    `}
`;

const Image = styled.img`
  width: 100%;
  object-fit: contain;
`;

const Title = styled.div`
  padding: 10px;
  font-size: 1em;

  text-align: center;

  flex: 1 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SpinnerWrapper = styled.div`
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default Courses;
